module.exports = __webpack_public_path__ + "img/coming-soon-img.462fa71a.png";